import { ButtonIcon } from 'components/Button';
import React from 'react';
import PropTypes from 'prop-types';
import { errorToast } from 'configuration/notifications';
import { InputAutoComplete } from 'components/InputAutoComplete/InputAutoComplete';

export const CashWarrantForm = ({
  cashWarrant,
  number,
  updateCashWarrant,
  removeCashWarrant,
  cashBoxes,
  isOnlyOneCashWarrant,
  saveCashWarrant,
  isUnofficialWarrant,
}) => {
  const save = () => {
    if (!cashWarrant.comment && isUnofficialWarrant) {
      errorToast('Комментарий обязателен для неофициального приходника!');
      return;
    }
    if (!cashWarrant.sum) {
      errorToast('Сумма должна быть больше нуля!');
      return;
    }
    if (!cashWarrant.selected) {
      errorToast('Нужно выбрать кассу!');
      return;
    }
    saveCashWarrant();
  };

  return (
    <div className="cash-warrant" key={cashWarrant.id}>
      <div className="cash-warrant-title">Кассовый ордер {number}</div>

      <div className="cash-warrant-group">
        <span>Сумма:</span>
        <input
          type="number"
          value={cashWarrant.sum}
          onChange={({ target: { value } }) => updateCashWarrant(cashWarrant.id, 'sum', Number(value))}
          className="cash-warrant-input cost"
        />
        <span>{isUnofficialWarrant ? 'у.е.' : 'грн.'}</span>
      </div>

      <div className="cash-warrant-group">
        <span>Касса:</span>
        <div className="warrant-selector">
          <InputAutoComplete
            icon="search"
            onChange={(newBox) => updateCashWarrant(cashWarrant.id, 'selected', newBox)}
            list={cashBoxes?.map((box) => ({
              value: box.cashboxID1C,
              text: box.name,
              returning: box,
            }))}
            selected={
              cashWarrant.selected ? { text: cashWarrant.selected.name, value: cashWarrant.selected.cashboxID1C } : null
            }
            placeholder="Касса..."
            type="text"
            size="auto"
          />
        </div>
      </div>

      <div className="cash-warrant-group">
        <input
          type="text"
          value={cashWarrant.comment}
          onChange={({ target: { value } }) => updateCashWarrant(cashWarrant.id, 'comment', value)}
          className="cash-warrant-input"
          placeholder="Комментарий..."
        />
      </div>
      <div className="flex-center">
        {!isOnlyOneCashWarrant && (
          <ButtonIcon
            className="btn-main"
            onClick={() => removeCashWarrant(cashWarrant.id)}
            icon="trash"
            text="Удалить"
          />
        )}
        <ButtonIcon className="btn-main" onClick={save} icon="plus-round" text="Сохранить" />
      </div>
    </div>
  );
};

CashWarrantForm.propTypes = {
  cashWarrant: PropTypes.any,
  number: PropTypes.number,
  updateCashWarrant: PropTypes.func,
  removeCashWarrant: PropTypes.func,
  cashBoxes: PropTypes.arrayOf(PropTypes.any),
  isOnlyOneCashWarrant: PropTypes.bool,
  saveCashWarrant: PropTypes.func,
  isUnofficialWarrant: PropTypes.bool,
};
